import { render, staticRenderFns } from "./SearchServiceNew.vue?vue&type=template&id=67f6583e"
import script from "./SearchServiceNew.vue?vue&type=script&lang=ts"
export * from "./SearchServiceNew.vue?vue&type=script&lang=ts"
import style0 from "./SearchServiceNew.vue?vue&type=style&index=0&id=67f6583e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports